module.exports = __webpack_public_path__ + "img/re.0592cb6f.png";